export default __webpack_public_path__ + "static/media/Hyundai_Creta_Fix.61c8f416.png";